export default __webpack_public_path__ + "static/media/p3.9c9f23f8.png";